module.exports = __webpack_public_path__ + "static/year2012-b930e6400f42ad0d94d4ee73df53c1a1.jpg";